const o=.32,t=.4,c=.37;export{o as FACE_DISTANCE_THRESHOLD,t as REDUCED_THRESHOLD,c as REDUCED_THRESHOLD_MOBILE};
